import React from 'react'
import { BsCheck2Circle } from "react-icons/bs";
export default function () {
  return (
    <div className='mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 bg-white pb-20  '>
<div className='grid grid-cols-1 items-baseline justify-between border-b border-gray-200 pb-6 pt-24'>
<div className=' grid w-full text-center items-center justify-center pb-6 '>
 <span className=' flex items-center justify-center'> <BsCheck2Circle className=' text-6xl text-green-600' /> </span>
 
<span className=' font-bold pb-2'>Xác nhận đơn hàng thành công!</span>
<span className=' italic' >PT2000 đã ghi nhận đơn hàng từ quý khách, nhân viên PT2000 sẽ liên hệ lại quý khách trong thời gian sớm nhất.</span>

</div>

<span >
Quý khách hàng thân mến,
</span>

<span className='pt-5'>
Chúng tôi xin gửi lời cảm ơn chân thành đến bạn vì đã tin tưởng và ủng hộ cửa hàng của chúng tôi bằng việc mua sắm tại đây. Chúng tôi rất trân trọng và tự hào về sự lựa chọn của bạn. <br/>
</span>

<span className='pt-5'>
Khách hàng luôn là nguồn động viên lớn lao cho chúng tôi để không ngừng hoàn thiện và mang đến những sản phẩm và dịch vụ tốt hơn. Chúng tôi cam kết luôn nỗ lực hết mình để đáp ứng những mong muốn và sở thích của bạn. <br/>
</span>

<span className='pt-5'>
Chúng tôi hi vọng rằng bạn sẽ thấy hài lòng với sản phẩm bạn đã mua và rằng chúng tôi có thể phục vụ bạn một lần nữa trong tương lai. Nếu bạn có bất kỳ câu hỏi hoặc ý kiến đóng góp nào, xin đừng ngần ngại liên hệ với chúng tôi. Chúng tôi luôn sẵn sàng lắng nghe và phục vụ bạn một cách tốt nhất. <br/>
</span>

<span className='pt-5'>
Cuối cùng, một lần nữa, xin cảm ơn bạn vì đã chọn chúng tôi. Chúng tôi mong rằng bạn sẽ luôn tìm thấy những sản phẩm thú vị và chất lượng tại cửa hàng của chúng tôi.<br/>
</span>

<span className='pt-5'>
Chúng tôi rất trân trọng sự ủng hộ của bạn.<br/>
</span>

<span className='pt-5 pb-10 text-right'>
Trân trọng<br/>
</span>
</div>
    </div>
  )
}
